import { render, staticRenderFns } from "./moveCandidateGroup.vue?vue&type=template&id=4bce56f4&scoped=true"
import script from "./moveCandidateGroup.vue?vue&type=script&lang=js"
export * from "./moveCandidateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce56f4",
  null
  
)

export default component.exports